import { render, staticRenderFns } from "./BuyerMyBiddings.vue?vue&type=template&id=5877a48c&scoped=true&"
import script from "./BuyerMyBiddings.vue?vue&type=script&lang=js&"
export * from "./BuyerMyBiddings.vue?vue&type=script&lang=js&"
import style0 from "./BuyerMyBiddings.vue?vue&type=style&index=0&id=5877a48c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5877a48c",
  null
  
)

export default component.exports